export const links = {
    home: "/",
    modepaiement: "/mode-de-paiement",
    paiement: "/paiement",
}
